import React from 'react'

import { useKindeCallbackLogic } from './KindeCallback.logic'
import { KindeCallbackView } from './KindeCallback.view'

const KindeCallback = () => {
  const logicResults = useKindeCallbackLogic()

  return <KindeCallbackView {...logicResults} />
}

export default KindeCallback
